<template>
<!--    故事会-->
    <div class="contain_item">
        <router-link class="box_class"
                     :to="{name:'ColumnStories', params:{code:itemData.code}}"
        >
            <img class="img_class" :src="itemData.cover" alt=""/>
            <div class="title_class">
              {{itemData.title}}
            </div>
        </router-link>
    </div>
</template>

<script>
export default{
    name:'stories',
    props:{
        itemProp:{
            type: Object,
            default(){
                return {}
            },
        }
    },
    data(){
        return {
            itemData:{}
        }
    },
    created(){
        this.initData()
    },
    methods:{
        initData(){
            this.itemData = this.itemProp;
            this.itemData.title = this.itemData.title || '';
            this.itemData.cover = this.itemData.cover || ''
        }
    }

}

</script>

<style scoped>
.contain_item{
    width:76vw;
    height:40vw;
    display:flex;
    justify-content: center;
    align-items: flex-end;
    box-sizing: border-box;

}

.box_class{
    width:90%;
    height:90%;
    display:inline-block;
    position: relative;
    box-sizing: border-box;
}
.img_class{
    width:100%;
    height:100%;
    object-fit: cover;
    position:relative;
    z-index: 5;
    box-sizing: border-box;
}


.title_class{
    width:35%;
    position: absolute;
    top: 45%;
    left: 12%;
    z-index:10;
    color:white;
    font-size:16px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: none;
    white-space: nowrap;
    box-sizing: border-box;

}


</style>
